export enum OrderbookFilterEnum {
  BIDS = "Bids",
  OFFERS = "Offers",
}

export enum OrderbookLayoutEnum {
  TAB = "tab",
  STACKED = "stacked",
  LARGE = "large",
}
